import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pSifremiUnuttum, rCore } from '../../models/.catalog';

export default class SifremiUnuttumApi extends ApiBase<pSifremiUnuttum, rCore> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/MobilSifremiUnuttum',
      }),
      options
    );
    this._ServiceUrl = '/services/Kullanici.asmx';
  }
}
